import { Component, OnInit, Input, Renderer2, } from "@angular/core";
import { ThemeService } from "../../services/theme.service";
import { LayoutService } from "../../services/layout.service";
import { TranslateService } from "@ngx-translate/core";
import { JwtAuthService } from "../../services/auth/jwt-auth.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-header-side",
  templateUrl: "./header-side.component.html",
})
export class HeaderSideComponent implements OnInit {
  @Input() notificPanel:any;
  public availableLangs = [
    {
      name: "EN",
      code: "en",
      flag: "flag-icon-us",
    },
    {
      name: "ES",
      code: "es",
      flag: "flag-icon-es",
    },
  ];
  currentLang = this.availableLangs[0];

  public egretThemes:any;
  public layoutConf: any;
  constructor(
    private themeService: ThemeService,
    private layout: LayoutService,
    public translate: TranslateService,
    private renderer: Renderer2,
    public jwtAuth: JwtAuthService,
    private router: Router
  ) { }
  ngOnInit() {
    this.egretThemes = this.themeService.egretThemes;
    this.layoutConf = this.layout.layoutConf;
    this.translate.use(this.currentLang.code);
  }
  setLang(lng:any) {
    this.currentLang = lng;
    this.translate.use(lng.code);
  }
  
  toggleNotific() {
    this.notificPanel.toggle();
    this.router.navigate([
      "/master",
      {
        outlets: { "form-outlet": ["fleet-detail"] },
      },
    ]);
  }
  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === "closed") {
      return this.layout.publishLayoutChange({
        sidebarStyle: "full",
      });
    }
    this.layout.publishLayoutChange({
      sidebarStyle: "closed",
    });
  }

  toggleCollapse() {
    // compact --> full
    if (this.layoutConf.sidebarStyle === "compact") {
      return this.layout.publishLayoutChange(
        {
          sidebarStyle: "full",
          sidebarCompactToggle: false,
        },
        { transitionClass: true }
      );
    }

    // * --> compact
    this.layout.publishLayoutChange(
      {
        sidebarStyle: "compact",
        sidebarCompactToggle: true,
      },
      { transitionClass: true }
    );
  }
}